import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../theme';
import { FA_SELECTOR } from '../../styles/variables';

export const useAdvancedFiltersPopupStyles = createStyles(({ token }) => ({
  // Overlay modifier composed with the shared `popup` base. `&&` self-doubles
  // so the width/padding outrank the base overlay rules.
  filterPopupOverlay: {
    '&&': {
      width: 480,

      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: 300,
      },

      '.ant-popover-inner-content': {
        paddingBottom: ThemeSpaces.SPACE_SM,
      },
    },
  },
  activeLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  filterPreviewIcon: {
    marginRight: ThemeSpaces.SPACE_SM,
    color: token.colorPrimary,
  },
  popupContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  popupContentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    borderBottom: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
  },
  popupContentTitle: {
    color: ThemeColors.COLOR_GREY4,
    fontSize: 24,
    fontWeight: 300,
  },
  popupContentClose: {
    cursor: 'pointer',
    color: token.colorPrimary,
    fontSize: 18,
    '&:hover': {
      opacity: 0.8,
    },
  },
  filterSetsControls: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: `${token.paddingSM}px ${ThemeSpaces.SPACE_NORM}px`,

      '.ant-btn-color-link.ant-btn-variant-link': {
        '&, &:hover': {
          color: token.colorPrimary,
          height: 'auto',
          border: 0,
          padding: 0,
        },
      },

      '.Popup-Label': {
        color: token.colorPrimary,
        cursor: 'pointer',
        fontWeight: 500,
        gap: ThemeSpaces.SPACE_SM,

        [FA_SELECTOR]: {
          margin: 0,
        },
      },
    },
  },
  advancedFiltersSections: {
    display: 'flex',
    flexDirection: 'column',
  },
  advancedFiltersSection: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gap: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,
    padding: ThemeSpaces.SPACE_NORM_20,
    borderTop: `1px solid ${token.colorWhite}`,

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      padding: ThemeSpaces.SPACE_NORM,
      gap: ThemeSpaces.SPACE_NORM,
    },

    '.ant-form-item': {
      marginBottom: 0,

      '.ant-select-selection-item': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'block',
      },
    },
  },
  popupContentFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${token.paddingSM}px ${ThemeSpaces.SPACE_NORM}px 0 ${ThemeSpaces.SPACE_NORM}px`,
    borderTop: `1px solid ${token.colorWhite}`,
  },
  clearAllLink: {
    color: token.colorPrimary,
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: token.fontSize,
    textDecoration: 'underline',
  },
  actionButtons: {
    display: 'flex',
    gap: ThemeSpaces.SPACE_NORM_20,

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      gap: ThemeSpaces.SPACE_NORM,
    },

    '&& .ant-btn': {
      height: 32,
      width: 110,
      padding: `0 ${ThemeSpaces.SPACE_SM}px`,
      fontWeight: 500,

      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: 80,
      },
    },
  },
  applyButton: {
    backgroundColor: token.colorPrimary,
    borderColor: token.colorPrimary,
    '&:hover': {
      backgroundColor: ThemeColors.COLOR_RED6,
      borderColor: ThemeColors.COLOR_RED6,
    },
  },
}));
